import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConversationStoreShallow } from 'src/store/conversationStore';

import { getPath } from '@services/RouteService/paths';

import { useReactiveVar } from '@apollo/client';
import {
    conversationDetailsVar,
    conversationSubmitLoadingVar,
} from '@boot/reactiveVariables';

export const useConversationRedirection = () => {
    const navigate = useNavigate();
    const conversationDetails = useReactiveVar(conversationDetailsVar);

    const { messages } = useConversationStoreShallow(['messages']);
    const conversationLength = messages.length;

    //TODO: TEMPORARY SOLUTION SPD-2948
    const conversationSubmitLoading = useReactiveVar(
        conversationSubmitLoadingVar,
    );

    useEffect(() => {
        if (!conversationSubmitLoading && !conversationLength)
            navigate(getPath({ path: '/new-conversation' }), { replace: true });

        if (!conversationSubmitLoading && !conversationDetails)
            navigate(getPath({ path: '/new-conversation' }), { replace: true });
    }, [conversationSubmitLoading, conversationLength, conversationDetails]);
};
